import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const ApplicationDetailsHeader = styled.div`
  @media screen and (max-width: ${({ theme }) =>
    theme.breakpoints?.values?.tablet + 'px'}){
      padding: 20px;
  };
`;

export const ApplicationDetailsHeaderButtons = styled.section`
  display: flex;
  justify-content: flex-end;
  button {
    width: auto;
    margin-right: 16px;
  }
  &:last-of-type {
    margin-top: 16px;
  }
`;

export const ApplicationDetailsHeaderButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 2rem;
`;

export const StatusBox = styled.div`
  border: 1px solid ${({ theme }) => theme.palette?.brand?.gray[300]};
  display: flex;
  border-radius: 10px;
  padding: 15.5px 24px;
  width: fit-content;
  align-items: center;
  span:first-of-type {
    margin-right: 32px;
  }
`;

export const StyledStatus = styled.div`
  display: flex;
  flex-direction: column;

  span {
    margin-top: -2rem;
    color: ${({ theme }) => theme.palette?.text?.secondary};
  }
`;
